import { Outlet, useLocation } from 'react-router';

import { useAuth } from '../auth/AuthProvider.tsx';
import { OfflineBanner } from '../sync/OfflineBanner.tsx';
import { SyncIndicator } from '../sync/SyncIndicator.tsx';
import { LogAction } from './LogAction.tsx';
import { NAV_ITEMS } from './nav.ts';
import { SideRail } from './SideRail.tsx';
import { TabBar } from './TabBar.tsx';

function sectionTitle(pathname: string): string {
  const match = NAV_ITEMS.find((item) => pathname.startsWith(item.to));
  return match?.label ?? 'ICULogbook';
}

export function AppShell() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  return (
    // No background of its own: the squared-paper pattern is painted on `body`,
    // and an opaque fill here would hide it. See the base layer in index.css.
    <div className="min-h-dvh">
      <SideRail />

      <div className="rail:pl-rail">
        {/*
          A slot as much as a header. The backup indicator sits on the right,
          visible from every screen — hazard H2 in COMPLIANCE.md is a trainee
          believing their work is safe when it is not.
        */}
        <header className="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur">
          <div className="mx-auto flex min-h-touch max-w-content items-center justify-between gap-3 px-4 pt-[env(safe-area-inset-top)]">
            <h1 className="font-serif text-lg font-strong tracking-tight">
              {sectionTitle(pathname)}
            </h1>
            <SyncIndicator userId={user?.id ?? null} />
          </div>
          <OfflineBanner />
        </header>

        <main
          id="main"
          className="mx-auto max-w-content px-4 py-5 pb-[calc(var(--ui-tabbar-height)+env(safe-area-inset-bottom)+5rem)] rail:pb-24"
        >
          <Outlet />
        </main>
      </div>

      {/* Nothing floats over the log form itself — it would cover Save. */}
      {pathname.startsWith('/log') ? null : <LogAction />}
      <TabBar />
    </div>
  );
}
